import { type JSX, Suspense, lazy } from "react";

import { TableControlLayoutProps } from "./TableControlLayoutProps";

const TableControlLazy = lazy(() => import("./TableControl"));

export function CustomTableControl(
  props: TableControlLayoutProps,
): JSX.Element {
  return (
    <Suspense>
      <TableControlLazy {...props} />
    </Suspense>
  );
}

export * from "./TableControlLayoutProps";
export * from "./useTableControlUiOptions";
export * from "./useTableControlStateDefaults";
export * from "./useTableControlReadonlyOptions";
